/** RTE-X11.4b — sequential stops save pipeline (feature-flagged). */

let saveFlagLogged = false;

/**
 * When unset: OFF in production, ON in development (mirrors read-mode default).
 * REACT_APP_SEQUENTIAL_STOPS_SAVE_MODE=true|false
 */
export function isSequentialStopsSaveModeEnabled(): boolean {
  const raw = process.env.REACT_APP_SEQUENTIAL_STOPS_SAVE_MODE;
  let enabled: boolean;
  if (raw === undefined || raw === '') {
    enabled = process.env.NODE_ENV === 'development';
  } else {
    enabled = String(raw).toLowerCase() === 'true';
  }
  if (process.env.NODE_ENV === 'development' && !saveFlagLogged) {
    saveFlagLogged = true;
    // eslint-disable-next-line no-console
    console.debug('[SequentialStopsSave] REACT_APP_SEQUENTIAL_STOPS_SAVE_MODE =', raw, '| enabled =', enabled);
  }
  return enabled;
}

export function isSequentialStopsSaveShadowDebugEnabled(): boolean {
  return process.env.REACT_APP_SEQUENTIAL_STOPS_SAVE_SHADOW_DEBUG === 'true';
}
